import { amplitude, ga } from 'js/analytics/adapters'
import { baseWebEventProps } from 'js/analytics/standardizedProps'

export const trackSelectPremiumSubscription = ({
  duration,
  discount = 0,
  coupon = '',
  entryPoint = '',
}) => {
  ga.track('select_premium_subscription', {
    subscription_duration: duration,
    discount: discount,
    entry_point: entryPoint,
    coupon,
  })
  amplitude.track('user_purchase_premium', {
    ...baseWebEventProps(),
    action_name: 'select',
    action_type: 'active',
    purchase_quantity: 1,
    ...(entryPoint ? { event_source: entryPoint } : {}),
    coupon,
    purchase_discount: discount,
    purchase_product_name: duration,
  })
}
